import React from 'react'
import { Txt } from '@vst/beam'
import styled from 'styled-components'

export const DeleteConsequence = (): JSX.Element => {
    return (
        <Box variant="bodySmallRegular" component="span">
            Type{' '}
            <Txt variant="bodySmallBold" className="delete" component="strong">
                DELETE
            </Txt>{' '}
            in the field below to confirm the action:
        </Box>
    )
}

export const DeleteConsequencePT = (): JSX.Element => {
    return (
        <Box variant="bodySmallRegular" component="span">
            Digite{' '}
            <Txt variant="bodySmallBold" className="delete" component="strong">
                DELETE
            </Txt>{' '}
            no campo abaixo para confirmar a ação:
        </Box>
    )
}

const Box = styled(Txt)`
    .delete {
        color: var(--beam-color-error);
    }
`
